import type { TFilestackTransformationInput } from '@atlas/tool/box/file/createFilestackImageURI';
import createFilestackImageURI from '@atlas/tool/box/file/createFilestackImageURI';
import isNotFalsy from '@atlas/tool/box/isNotFalsy';

/**
 * Lightweight helper to display previews across front-end applications.
 *
 * Refer to **createFilestackImageURI** when you need more control.
 */
export default function createPreviewUrl(input: TFilestackTransformationInput, height: number): string {
    let isImage = false;
    if (input.url) {
        isImage = isNotFalsy(input.url.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/i));
    }
    // Images can be previewed in WEBP, which loads faster. Other formats require JPG.
    const output = isImage ? 'auto' : 'jpg';

    return createFilestackImageURI(input, { output, resize: { height, fit: 'clip' } });
}
